import AtBackLink from '../atoms/AtBackLink';
import AtMainButton from '../atoms/AtMainButton';

type Props = {
  backLabel: string;
  backUrl: string;
  onClickBackLink?: (e: React.UIEvent<Element, UIEvent>) => void;
  mainLabel: string;
  disabled?: boolean;
  onClick?: (e: React.UIEvent<Element, UIEvent>) => void;
};
/**
 * コンポーネント描画
 * @param 属性定義
 * @returns コンポーネント
 */
const OrButtonArea = ({
  backLabel,
  backUrl,
  onClickBackLink,
  mainLabel,
  disabled,
  onClick,
}: Props) => {
  return (
    <div className='orbuttonarea'>
      <AtBackLink href={backUrl} className='back' onClickBackLink={onClickBackLink}>
        {backLabel}
      </AtBackLink>
      <AtMainButton name='main' className='main' disabled={disabled} onClick={onClick}>
        {mainLabel}
      </AtMainButton>
    </div>
  );
};
/** 初期値の設定 */
OrButtonArea.defaultProps = {
  onClickBackLink: null,
  disabled: false,
  onClick: null,
};
/** 初期値の設定 */
export default OrButtonArea;
